import { SliderTick } from 'platform/components';
import { isNotNil } from 'ramda';
const MAX_SLIDER_TICKS = 30;
export const useSliderTicks = (min: number, max: number, markerSize: number | null, markers?: Array<number>): undefined | Array<SliderTick> => {
  const numOfTicksByMarkerSize = markerSize ? Math.floor(Math.abs(max - min) / markerSize) : 0;
  if (markers && markers.length > 0) {
    return markers?.map(marker => ({
      label: marker.toString(),
      value: marker
    }));
  }
  if (isNotNil(markerSize) && markerSize !== 0 && numOfTicksByMarkerSize < MAX_SLIDER_TICKS) {
    const calculatedMarkers: Array<SliderTick> = [];
    let lastMarkerValue: number = min;
    while (lastMarkerValue <= max) {
      calculatedMarkers.push({
        value: lastMarkerValue
      });
      lastMarkerValue = lastMarkerValue + markerSize;
    }
    return calculatedMarkers;
  }
  return undefined;
};